import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'CoreTenantDrawerLinksEdit',
  components: {
    codemirror: codemirror
  },
  props: {
    tenantTheme: {
      type: Object,
      required: true
    },
    // the indicies in order to get to the nested drawer-link-items
    hierarchyIndices: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      codeMirrorInstances: {},
      cmLineNumbers: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    linkItems: function linkItems() {
      if (this.hierarchyIndices.length === 0) {
        return this.tenantTheme.drawerLinks;
      }

      var indicies = this.hierarchyIndices.map(function (i) {
        return "[".concat(i, "].children");
      });
      return get(this.tenantTheme.drawerLinks, "".concat(indicies.join('.')));
    },
    linkItemTypes: function linkItemTypes() {
      return [this.hierarchyIndices.length === 0 ? {
        value: 'category',
        text: 'CATEGORY'
      } : null, {
        value: 'group',
        text: 'GROUP'
      }, {
        value: 'link',
        text: 'LINK'
      }].filter(function (lit) {
        return lit;
      });
    },
    indentWidth: function indentWidth() {
      return this.hierarchyIndices.length * 40;
    },
    routerPaths: function routerPaths() {
      return this.$router.options.routes.map(function (r) {
        return r.path;
      }).concat(['GRAFANA_PLACEHOLDER', 'FIREFLY_PLACEHOLDER']);
    },
    cmOptions: function cmOptions() {
      return {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      };
    }
  }),
  methods: {
    togglePermissionEditor: function togglePermissionEditor(index) {
      this.codeMirrorInstances[index] = !this.codeMirrorInstances[index];
      this.codeMirrorInstances = cloneDeep(this.codeMirrorInstances);
    },
    refreshForm: function refreshForm(index) {
      var _this2 = this;

      setTimeout(function () {
        if (get(_this2.$refs, "codemirror_nested_".concat(_this2.hierarchyIndices, "_").concat(index, ".codemirror"))) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          _this2.$refs["codemirror_nested_".concat(_this2.hierarchyIndices, "_").concat(index)].codemirror.refresh();

          _this2.$refs["codemirror_nested_".concat(_this2.hierarchyIndices, "_").concat(index)].codemirror.focus();
        }
      }, 50);
    },
    onCmFocus: function onCmFocus(index) {
      this.refreshForm(index);
      this.cmLineNumbers = true;
    },
    finishedPermissionEditing: function finishedPermissionEditing(linkItem) {
      try {
        linkItem.permissions = JSON.parse(linkItem.permissionsJsonString);
        delete linkItem.permissionJsonError;
      } catch (e) {
        linkItem.permissionJsonError = e;
      }

      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('drawerlinks-changed');
    },
    changeDrawerLinksOrder: function changeDrawerLinksOrder(index, direction) {
      var newIndex = Math.min(this.linkItems.length - 1, Math.max(0, index + (direction === 'up' ? -1 : 1)));

      if (newIndex !== index) {
        var priorElement = this.linkItems[newIndex];
        this.linkItems[newIndex] = this.linkItems[index];
        this.linkItems[index] = priorElement;
      }

      this.emitChange();
    },
    changedLinkItemType: function changedLinkItemType(j) {
      if (this.linkItems[j].type === 'group') {
        if (!this.linkItems[j].children) {
          this.linkItems[j].children = [];
        }
      }

      this.emitChange();
    },
    addLinkItem: function addLinkItem() {
      this.linkItems.push({
        type: 'link',
        children: [],
        permissionsJsonString: '{}'
      });
      this.emitChange();
    },
    addGroupItem: function addGroupItem(j) {
      if (!this.linkItems[j].children) {
        this.linkItems[j].children = [];
      }

      this.linkItems[j].children.push({
        type: 'link',
        children: [],
        permissionsJsonString: '{}'
      });
      this.emitChange();
    },
    removeLinkItem: function removeLinkItem(index) {
      pullAt(this.linkItems, [index]);
      this.emitChange();
    },
    removeLinkItems: function removeLinkItems() {
      this.$emit('remove');
      this.emitChange();
    }
  }
};